export function ThrashIcon({ ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='13' height='14' viewBox='0 0 13 14' {...props}>
      <g id='Icon_feather-trash-2' data-name='Icon feather-trash-2' transform='translate(-3 -1.5)'>
        <path
          id='Union_1'
          data-name='Union 1'
          d='M3.25,14A1.932,1.932,0,0,1,1.3,12.091V3.818H.65a.637.637,0,1,1,0-1.273h2.6V1.909A1.932,1.932,0,0,1,5.2,0H7.8A1.932,1.932,0,0,1,9.75,1.909v.636h2.6a.637.637,0,1,1,0,1.273H11.7v8.272A1.932,1.932,0,0,1,9.75,14ZM2.6,12.091a.644.644,0,0,0,.65.637h6.5a.644.644,0,0,0,.65-.637V3.818H2.6ZM8.45,2.545V1.909A.644.644,0,0,0,7.8,1.273H5.2a.644.644,0,0,0-.649.636v.636Zm-1.3,7.636V6.364a.65.65,0,0,1,1.3,0v3.818a.65.65,0,0,1-1.3,0Zm-2.6,0V6.364a.65.65,0,0,1,1.3,0v3.818a.65.65,0,0,1-1.3,0Z'
          transform='translate(3 1.5)'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
